import React from "react";
import { AHSeparator } from "arkh";

export const WACategoryItemSeparator = () => {
  return <AHSeparator spaceBottom="xlarge" />;
};
